export default __webpack_public_path__ + "static/media/welcome.013bb669.svg";